module.exports = __webpack_public_path__ + "img/아이콘_배고픈-판다_ver.7b13d74b.png";